import { render, staticRenderFns } from "./PartnerHeader.vue?vue&type=template&id=71ff06b0&scoped=true&"
import script from "./PartnerHeader.vue?vue&type=script&lang=ts&"
export * from "./PartnerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerHeader.vue?vue&type=style&index=0&id=71ff06b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff06b0",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
